import { render, staticRenderFns } from "./VariableSelectorItem.vue?vue&type=template&id=afbec37c&scoped=true&"
import script from "./VariableSelectorItem.vue?vue&type=script&lang=ts&"
export * from "./VariableSelectorItem.vue?vue&type=script&lang=ts&"
import style0 from "./VariableSelectorItem.vue?vue&type=style&index=0&id=afbec37c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbec37c",
  null
  
)

export default component.exports